module.exports = __webpack_public_path__ + "img/40.cb7215ac.gif";